import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-20/task-02";

const task: Slide = {
  titleHtml:
    "In the low frequency approximation, the shape of the pressure<br>response of a closed-box system has the form of a...",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
